// extracted by mini-css-extract-plugin
export default {"dialog":"InfoDialog_dialog__Ca3Gg"};